import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Logging centralizado: en producción se omiten log/info/warn/debug;
 * los errores siempre se envían a consola para diagnóstico (mismo comportamiento que `console.error` directo).
 */
@Injectable({ providedIn: 'root' })
export class LoggerService {
  debug(message: string, ...args: unknown[]): void {
    if (!environment.production) {
      console.debug(message, ...args);
    }
  }

  log(message: string, ...args: unknown[]): void {
    if (!environment.production) {
      console.log(message, ...args);
    }
  }

  info(message: string, ...args: unknown[]): void {
    if (!environment.production) {
      console.info(message, ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (!environment.production) {
      console.warn(message, ...args);
    }
  }

  error(message: string, ...args: unknown[]): void {
    console.error(message, ...args);
  }

  /** Solo no producción: métricas locales (equivalente a `console.time`). */
  time(label: string): void {
    if (!environment.production) {
      console.time(label);
    }
  }

  /** Solo no producción: cierre de métricas locales (equivalente a `console.timeEnd`). */
  timeEnd(label: string): void {
    if (!environment.production) {
      console.timeEnd(label);
    }
  }
}
